import Api from "../../../../util/Api";

// Orvos feü sablonok
export default function getInitState() {
    return {
        gridIsOpen: true,
        formIsOpen: false,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új sablon',
                event_name: "customClick",
                class: "btn btn-success",
                event_payload: 'newRow'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning mx-1",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary mx-1",
                event_payload: 'resetForm'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow',
                additionalButtonVisible: "isEditORDeleteButtonVisibleInEmployAbilityDoctorTemplate"
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow',
                additionalButtonVisible: "isEditORDeleteButtonVisibleInEmployAbilityDoctorTemplate"
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow',
                additionalButtonVisible: "isUnDeletedButtonVisibleInEmployAbilityDoctorTemplate"
            }
        ],
        searchHeaderFields: [
            {
                name: "doctorId",
                label: "Orvos",
                formSize: 3,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.findAllOccupationHealthDoctors,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "employabilityTypeId",
                label: "Munkaalkalmassági vélemény típusa",
                formSize: 4,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getEmployabilityTypes,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false
            },
            {
                name: "doctorId",
                label: "doctorId",
                visibility: false
            },
            {
                name: "doctor.fullName",
                label: "Orvos",
                visibility: true
            },
            {
                name: "employabilityType.text",
                label: "Munkaalkalmassági vélemény típusa",
                visibility: true
            },
            {
                name: "doctorId",
                label: "Orvos",
                visibility: false,
                formVisible: true,
                formRequired: true,
                formSize: 3,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.findAllOccupationHealthDoctors,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "employabilityTypeId",
                label: "Munkaalkalmassági vélemény típusa",
                visibility: false,
                formVisible: true,
                formSize: 6,
                formType: "select",
                formRequired: true,
                selectOptions: {
                    apiCallback: Api.getEmployabilityTypes,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "complaints",
                label: "Panaszok",
                visibility: false,
                formVisible: true,
                formSize: 6,
                formType: "textarea",
                viewModalShow: true
            },
            {
                name: "medicalHistory",
                label: "Kórelőzmény",
                visibility: false,
                formVisible: true,
                formSize: 6,
                formType: "textarea",
            },
            {
                name: "skinAndVisibleMucosa",
                label: "Bőr és látható nyálkahártyák",
                visibility: false,
                formVisible: true,
                formSize: 3,
                maxLength: 255,
                formType: "text"
            },
            {
                name: "thyroid",
                label: "Mirigyek (pajzsmirigy)",
                visibility: false,
                formVisible: true,
                formSize: 3,
                maxLength: 255,
                formType: "text"
            },
            {
                name: "bonesAndJoints",
                label: "Csontok és ízületek",
                visibility: false,
                formVisible: true,
                formSize: 3,
                maxLength: 255,
                formType: "text"
            },
            {
                name: "flatfoot",
                label: "Lúdtalp",
                visibility: false,
                formVisible: true,
                formSize: 3,
                maxLength: 255,
                formType: "customRadioButton"
            },
            {
                name: "mouthNoseAndPharynxFormulas",
                label: "Száj-, orr- és garatképletek",
                visibility: false,
                formVisible: true,
                formSize: 3,
                maxLength: 255,
                formType: "text"
            },
            {
                name: "toothCondition",
                label: "Fogazat",
                visibility: false,
                formVisible: true,
                formSize: 3,
                maxLength: 255,
                formType: "text"
            },
            {
                name: "lungs",
                label: "Tüdő",
                visibility: false,
                formVisible: true,
                formSize: 3,
                maxLength: 255,
                formType: "text"
            },
            {
                name: "heart",
                label: "Szív",
                visibility: false,
                formVisible: true,
                formSize: 3,
                maxLength: 255,
                formType: "text"
            },
            {
                name: "ekg",
                label: "EKG",
                visibility: false,
                formVisible: true,
                formSize: 3,
                maxLength: 100,
                formType: "text"
            },
            {
                name: "rowBreak11",
                label: "rowBreak",
                rowBreak: true,
                formSize: 9,
                visibility: false,
                formVisible: true
            },
            {
                name: "vascularSystem",
                label: "Érrendszer (variocositas, nodus)",
                visibility: false,
                formVisible: true,
                formSize: 3,
                maxLength: 255,
                formType: "text"
            },
            {
                name: "gastric",
                label: "Hasi szervek tapintása",
                visibility: false,
                formVisible: true,
                formSize: 3,
                maxLength: 255,
                formType: "text"
            },
            {
                name: "nervousSystem",
                label: "Idegrendszer, Romberg",
                visibility: false,
                formVisible: true,
                formSize: 3,
                maxLength: 255,
                formType: "text"
            },
            {
                name: "rowBreak6",
                label: "rowBreak",
                rowBreak: true,
                formSize: 3,
                visibility: false,
                formVisible: true
            },
            {
                name: "liver",
                label: "Máj",
                visibility: false,
                formVisible: true,
                formSize: 3,
                maxLength: 100,
                formType: "text"
            },
            {
                name: "hernia",
                label: "Sérv",
                visibility: false,
                formVisible: true,
                formSize: 3,
                maxLength: 100,
                formType: "text"
            },
            {
                name: "rowBreak9",
                label: "rowBreak",
                rowBreak: true,
                formSize: 6,
                visibility: false,
                formVisible: true
            },
            {
                name: "balance",
                label: "Halló- és egyensúlyszerv",
                visibility: false,
                formVisible: true,
                formSize: 3,
                maxLength: 100,
                formType: "text"
            },
            {
                name: "hearingRight",
                label: "Hallás (jobb)",
                visibility: false,
                formVisible: true,
                formSize: 3,
                maxLength: 100,
                formType: "text"
            },
            {
                name: "hearingLeft",
                label: "Hallás (bal)",
                visibility: false,
                formVisible: true,
                formSize: 3,
                maxLength: 100,
                formType: "text"
            },
            {
                name: "rowBreak7",
                label: "rowBreak",
                rowBreak: true,
                formSize: 3,
                visibility: false,
                formVisible: true
            },
            {
                name: "seeingRight",
                label: "Távollátás (jobb)",
                visibility: false,
                formVisible: true,
                formSize: 3,
                maxLength: 100,
                formType: "text"
            },
            {
                name: "seeingLeft",
                label: "Távollátás (bal)",
                visibility: false,
                formVisible: true,
                formSize: 3,
                maxLength: 100,
                formType: "text"
            },
            {
                name: "rowBreak10",
                label: "rowBreak",
                rowBreak: true,
                formSize: 6,
                visibility: false,
                formVisible: true
            },
            {
                name: "seeingCloseRight",
                label: "Közellátás (jobb)",
                visibility: false,
                formVisible: true,
                formSize: 3,
                maxLength: 100,
                formType: "text"
            },
            {
                name: "seeingCloseLeft",
                label: "Közellátás (bal)",
                visibility: false,
                formVisible: true,
                formSize: 3,
                maxLength: 100,
                formType: "text"
            },
            {
                name: "rowBreak12",
                label: "rowBreak",
                rowBreak: true,
                formSize: 6,
                visibility: false,
                formVisible: true
            },
            {
                name: "eyes",
                label: "Szem (visus)",
                visibility: false,
                formVisible: true,
                formSize: 3,
                maxLength: 100,
                formType: "text"
            },
            {
                name: "colorSeeing",
                label: "Színlátás",
                visibility: false,
                formVisible: true,
                formSize: 3,
                maxLength: 100,
                formType: "text"
            },
            {
                name: "rowBreak14",
                label: "rowBreak",
                rowBreak: true,
                formSize: 6,
                visibility: false,
                formVisible: true
            },
            {
                name: "hasGlasses",
                label: "Szemüveg",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "customRadioButton"
            },
            {
                name: "hasContactLens",
                label: "Kontaktlencse",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "customRadioButton"
            },
            {
                name: "rowBreak13",
                label: "rowBreak",
                rowBreak: true,
                formSize: 8,
                visibility: false,
                formVisible: true
            },
            {
                name: "createdBy",
                label: "Létrehozó",
                visibility: true
            },
            {
                name: "createdOn",
                label: "Létrehozás időpontja",
                slot_name: "created_on_format",
                visibility: true
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            },
            {
                name: "resultsOfAdditionalTests",
                label: "Kiegészítő szakvizsgálatok eredményei",
                visibility: false,
                formVisible: true,
                formSize: 6,
                formType: "textarea",
            },
            {
                name: "laboratory",
                label: "Laboratóriumi vizsgálati eredmények",
                visibility: false,
                formVisible: true,
                formSize: 6,
                formType: "textarea",
            },
            {
                name: "psychologicalTest",
                label: "Pszichológiai vizsgálat eredménye",
                visibility: false,
                formVisible: true,
                formSize: 6,
                formType: "textarea",
            },
            {
                name: "rowBreak66",
                label: "rowBreak",
                rowBreak: true,
                formSize: 6,
                visibility: false,
                formVisible: true
            },
            {
                name: "note",
                label: "Megjegyzés",
                visibility: false,
                formVisible: true,
                formSize: 6,
                formType: "text",
            },
            {
                name: "rowBreak67",
                label: "rowBreak",
                rowBreak: true,
                formSize: 6,
                visibility: false,
                formVisible: true
            },
            {
                name: "validityDef",
                label: "Érvényesség",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "select",
                selectOptions: {
                    externalOptionList: [
                        { id: -1, text: 'Egyéni érvényesség' },
                        { id: 1, text: '1 hónap' },
                        { id: 3, text: '3 hónap' },
                        { id: 6, text: '6 hónap' },
                        { id: 12, text: '12 hónap' },
                        { id: 24, text: '24 hónap' },
                    ],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            }
        ]
    }
}
